import { createFileRoute } from "@tanstack/react-router";
import { AccountShell } from "@/components/klantaccount";
import { klantaccountQuery } from "@/lib/klantaccount.functions";
export const Route = createFileRoute("/_authenticated/account")({
  loader: ({ context }) => context.queryClient.ensureQueryData(klantaccountQuery()),
  component: AccountShell,
});